import { Query } from '@/app/tracking/api';

export interface QueryQuestionsTrackingQueryPayload {
  ids: string[] | 'all'
}

export interface QueryQuestionsTrackingQueryResult {
  questions: QuestionState[]
}

export function defaultQuestionState(id: string): QuestionState {
  return { id, attempts: [] }
}

export interface QuestionState {
  id: string;
  attempts: QuestionAttempt[];
}

interface QuestionAttempt {
  timestamp: Date;
  response: string;
  score: number;
  durationSeconds: number;
}


export const QueryQuestionsTrackingQueryName = 'query-questions' as const
export type QueryQuestionsTrackingQuery =
      Query<typeof QueryQuestionsTrackingQueryName, QueryQuestionsTrackingQueryPayload, QueryQuestionsTrackingQueryResult>
